import { QuotaUsageType } from "@common-shared/config/oneVerify/oneVerifyCoverage.config"
import { COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG } from "@common-shared/config/oneVerify/oneVerifyPoliciesColumns.config"
import { IPolicyColumnConfiguration } from "@common-shared/types/policies.types"

export const POLICIES_COLUMNS_CONFIG = {
    ...COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG,

    defaultColumnWidth: 250,

    get checkerDownloadResultsColumns(): Record<
        QuotaUsageType,
        IPolicyColumnConfiguration[]
    > {
        const standardColumns = [
            // INPUT DATA
            POLICIES_COLUMNS_CONFIG.columnsConfig.MODALITY_CODE_UNMAPPED,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PROVIDER_NPI,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PROVIDER_SESSION_CHARGE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PAYER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_FIRST_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_LAST_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.CPT_CODE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK_RAW,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_TYPE_UNMAPPED,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_NEXT_APPOINTMENT_DATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,

            // RESULT DATA
            POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.RESPONSE_STATUS,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUEST_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.RESULT_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.COVERAGE_STATUS,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_BEGIN_DATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_END_DATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.TOTAL_DEDUCTIBLE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REMAINING_DEDUCTIBLE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.TOTAL_OOP_MAX,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REMAINING_OOP_MAX,
            POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_OBLIGATION,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PAYER_OBLIGATION,
            POLICIES_COLUMNS_CONFIG.columnsConfig.POST_DEDUCTIBLE_SESSION_RATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.POST_OOM_MAX_SESSION_RATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_SESSIONS_BEFORE_DEDUCTIBLE,
            POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_SESSIONS_BEFORE_OOP_MAX,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_GENDER,
            POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ADDRESS,
            POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.RELATIONSHIP_TO_SUBSCRIBER,
            POLICIES_COLUMNS_CONFIG.columnsConfig.SUBSCRIBER_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.SUBSCRIBER_DOB,
            POLICIES_COLUMNS_CONFIG.columnsConfig.SUBSCRIBER_MEMBER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.ELIGIBILITY_END_DATE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.INSURANCE_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.ADDITIONAL_POLICY_PAYER,
            POLICIES_COLUMNS_CONFIG.columnsConfig.ADDITIONAL_POLICY_MEMBER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.ADDITIONAL_POLICY_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.BENEFIT_STRUCTURE,

            POLICIES_COLUMNS_CONFIG.columnsConfig.TELEHEALTH_COPAYMENT,
            POLICIES_COLUMNS_CONFIG.columnsConfig.TELEHEALTH_COINSURANCE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.TELEHEALTH_BENEFIT_STRUCTURE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.TELEHEALTH_MEMBER_OBLIGATION,

            ...POLICIES_COLUMNS_CONFIG.dataCorrectionColumns,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUESTED_PAYER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUESTED_PATIENT_FIRST_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUESTED_PATIENT_LAST_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUESTED_MEMBER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.REQUESTED_PATIENT_DOB,

            POLICIES_COLUMNS_CONFIG.columnsConfig.ERROR_CODE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.ERROR_MESSAGE,
            POLICIES_COLUMNS_CONFIG.columnsConfig.QMB_STATUS,
            POLICIES_COLUMNS_CONFIG.columnsConfig.MEDICARE_ADVANTAGE_PAYER_NAME,
            POLICIES_COLUMNS_CONFIG.columnsConfig.MEDICARE_ADVANTAGE_PAYER_ID,
            POLICIES_COLUMNS_CONFIG.columnsConfig.MEDICARE_ADVANTAGE_MEMBER_ID,
        ]

        return {
            [QuotaUsageType.GENERAL]: [
                ...standardColumns,

                POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK_STATUS_ALERT,
                POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK_STATUS_VERSION,
                POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK_STATUS_RULE_ID,
            ],
            [QuotaUsageType.DISCOVER]: standardColumns,
            [QuotaUsageType.SMART_SCAN]: standardColumns,
            [QuotaUsageType.AGENTIC_PORTAL]: standardColumns,
            [QuotaUsageType.AGENTIC_PHONE]: standardColumns,

            [QuotaUsageType.MEDICAID]: [
                POLICIES_COLUMNS_CONFIG.columnsConfig.MODALITY_CODE_UNMAPPED,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PROVIDER_NPI,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_STATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_FIRST_NAME,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_LAST_NAME,
                POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_GENDER_UNMAPPED,
                POLICIES_COLUMNS_CONFIG.columnsConfig.CPT_CODE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_TYPE_UNMAPPED,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .PATIENT_NEXT_APPOINTMENT_DATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,

                // RESULT DATA
                POLICIES_COLUMNS_CONFIG.columnsConfig.MANAGED_CARE_ORGANIZATION,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ELIGIBILITY_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
                POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.RESPONSE_STATUS,
                POLICIES_COLUMNS_CONFIG.columnsConfig.REQUEST_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig.RESULT_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_BEGIN_DATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_END_DATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
                POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_NAME,
                POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ADDRESS,
                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .THIRD_PARTY_ADMINISTRATOR_NAME,
                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .THIRD_PARTY_ADMINISTRATOR_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ERROR_CODE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ERROR_MESSAGE,

                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .RELATIONSHIP_TO_SUBSCRIBER,
                POLICIES_COLUMNS_CONFIG.columnsConfig.SUBSCRIBER_DOB,
                POLICIES_COLUMNS_CONFIG.columnsConfig.SUBSCRIBER_MEMBER_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ELIGIBILITY_END_DATE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.INSURANCE_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ADDITIONAL_POLICY_PAYER,
                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .ADDITIONAL_POLICY_MEMBER_ID,
                POLICIES_COLUMNS_CONFIG.columnsConfig.ADDITIONAL_POLICY_TYPE,
                POLICIES_COLUMNS_CONFIG.columnsConfig
                    .ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
            ],
        }
    },
}
